import { appInsights } from "us.helper";
import { ICaseSubCasesFrom } from "../Interfaces";
import { ICase } from "us.collection.transactions/interfaces";
import { CaseType } from "us.helper/types/enums";
import { isSelectSameAdditionalReferenceCases } from "./IsSelectSameAdditionalReferenceCases";

/**
 * @function
 * @description - Check for the desition to dissable the merge-case button
 * @param {ICaseSubCasesFrom} values - form values
 * @param {ICase} casesAndSubCases[] - casesAndSubCases
 * @return {*}  {boolean} - boolean decision if the merge case button is dissabled
 */
export const isMergeCaseButtonDisabled = (
  values: ICaseSubCasesFrom,
  casesAndSubCases: ICase[]
): boolean => {
  try {
    const selectedCases = values.selectedCases ?? [];

    const hasAdditionalRefSelectedCases = selectedCases.some(
      (caseItem) =>
        caseItem.additionalReference1 || caseItem.additionalReference2
    );

    const cases = casesAndSubCases?.filter(
      (caseItem) => caseItem.caseType === CaseType.C && caseItem.parentId > 0
    );

    let isMergeDisabled = true;
    let isAdditionalRefValidMergeCase = false;
    let isNoneAdditionalRefValidMergeCase = false;

    if (hasAdditionalRefSelectedCases) {
      if (selectedCases.length === 1) {
        const selectedCase = selectedCases[0];
        isAdditionalRefValidMergeCase = cases.some(
          (c) =>
            c.caseId &&
            c.caseId !== selectedCase.caseId &&
            c.additionalReference1 === selectedCase.additionalReference1 &&
            c.additionalReference2 === selectedCase.additionalReference2 &&
            c.additionalReference3 === selectedCase.additionalReference3
        );
      } else {
        isAdditionalRefValidMergeCase =
          isSelectSameAdditionalReferenceCases(selectedCases);
      }
    } else {
      isNoneAdditionalRefValidMergeCase =
        selectedCases.length === 1
          ? cases.some(
              (c) =>
                c.caseId &&
                c.caseId !== selectedCases[0].caseId &&
                !c.additionalReference1 &&
                !c.additionalReference2 &&
                c.isMergeEnabled
            )
          : true;
    }

    if (
      (isAdditionalRefValidMergeCase && hasAdditionalRefSelectedCases) ||
      (isNoneAdditionalRefValidMergeCase && !hasAdditionalRefSelectedCases)
    ) {
      isMergeDisabled =
        selectedCases.filter(
          (caseItem) => caseItem.parentId > 0 && caseItem.isMergeEnabled
        ).length < 1 ||
        selectedCases.filter((caseItem) => !caseItem.isMergeEnabled).length > 0;
    } else {
      isMergeDisabled = true;
    }

    return isMergeDisabled;
  } catch (error) {
    appInsights.trackException(
      `Cases and Subcases Home isMergeCaseButtonDisabled error - ${error}`
    );
    return true;
  }
};
